<span class="cerrix-color-box" [style.background-color]="color"></span>
